import React, { useEffect, useState } from "react";
import { Typography, FormControlLabel, FormControl, Checkbox, RadioGroup } from '@mui/material';
import ModalFooter from "../../../Modal/ModalFooter/ModalFooter";

export default function StepNine(props) {
    const [buttons, setButtons] = useState(
        [
            {
                'function': props.prev,
                'text': 'Précedent',
                'disabled': false,
                'color': 'error'
            },
            {
                'function': props.next,
                'text': 'Suivant',
                'disabled': true,
                'color': 'success'
            }
        ]);

        useEffect(() => {
            if (props.datas.consequences && Object.keys(props.datas.consequences).length >= 1) {
                buttons[1].disabled = false;
            } else {
                buttons[1].disabled = true;
            }
            setButtons([...buttons]);
        }, [props.datas]);

    function handleChange(e){
        let datas = Object.assign({}, props.datas);
        if(!datas.consequences){
            datas.consequences = [];
        }
        let filtered = datas.consequences.filter( data => data != e.target.value);
        if(e.target.checked){
            filtered.push(e.target.value);
        }
        datas.consequences = filtered;
        props.handleChange(datas);
    }

    return (
        <>
            <Typography id="modal-modal-description" variant="p">
                Selon vous, dans l’ensemble, pensez-vous que la « location de logements à court et moyen terme » : (Plusieurs réponses possibles)
            </Typography>
            <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                <FormControl component="fieldset">
                    <RadioGroup
                        aria-label="gender"
                        defaultValue="public"
                        defaultValue={props.datas.consequences}
                        name="radio-buttons-group">
                        <FormControlLabel value="Aucune conséquence" control={<Checkbox name='consequences' onChange={(e) => handleChange(e)}/>} label="Aucune conséquence"/>
                        <FormControlLabel value="Changement du mode location en faveur d’un bail traditionnel" control={<Checkbox name='consequences' onChange={(e) => handleChange(e)}/>} label="Changement du mode location en faveur d’un bail traditionnel" />
                        <FormControlLabel value="Retrait définit du marché de la location" control={<Checkbox name='consequences' onChange={(e) => handleChange(e)}/>} label="Retrait définit du marché de la location" />
                        <FormControlLabel value="Mise en vente" control={<Checkbox name='consequences' onChange={(e) => handleChange(e)}/>} label="Mise en vente" />
                    </RadioGroup>
                </FormControl>
            </Typography>
            <ModalFooter buttons={buttons}/>
        </>
    )
}